export { default } from './AssemblyTwoCells';
